const keys = {
  confirmation: {
    fieldsTitles: {
      carVins: 'Vehicle Identification Number (VIN)',
      coInsured: {
        birthday: 'Date of birth',
        firstName: 'First name',
        lastName: 'Last name',
        occupation: 'Occupation',
        relationship: 'Relationship',
        school: 'Name of study institution',
        workplace: 'Employer',
      },
      homeCreditor: {
        name: 'Mortgage lender name',
        address: 'Mortgage lender address',
      },
      effectiveDate: 'Effective date',
      licenceNumbers: 'Licence Number',
      school: 'Name of study institution',
      workplace: 'Workplace',
    },
    helpers: {
      mobileAppTracking: {
        intact: {
          title: "Intact's my Drive Application",
          description:
            'This policy is part of the my Drive program and helps you get rewarded for your good driving habits.<0></0>You automatically receive a 10% enrollment discount when you sign up for my Drive.<0></0><0></0>To maintain your discount, you must install the Intact mobile app, activate the my Drive option, and continuously use the app. If the mobile app is not used, you will lose your discount.<0></0><0></0> The discount will then be adjusted each year based on your driving habits and could reach up to 25%.<0></0><0></0>Intact will send you an email with the instructions to download the app in the next few days following the purchase of your policy with us. You can opt out of my Drive at any time.',
        },
        travelers: {
          title: "Traveler's IntelliDrive Application",
          description:
            'This policy is part of the IntelliDrive program and helps you get rewarded for your good driving habits.<0></0>You automatically receive a 2.5% enrollment discount when you sign up for IntelliDrive.<0></0><0></0>To maintain your discount, you must install the Travelers mobile app, activate the IntelliDrive option, and use the app to capture driving data over a 90-day evaluation period. You must drive at least 800km during the 90 days to complete the evaluation. Your driving habits are scored, and if you drive safely, you could save up to 30% when your policy renews.<0></0><0></0>Travelers will send you an email with the instructions to download the app in the next few days following the purchase of your policy with us. You can opt out of IntelliDrive at any time.',
        },
      },
      carVin: {
        description:
          'You can find the vehicle identification number (VIN) on your registration certificate. The VIN is a unique code composed of 17 characters.',
        title: 'Where can I find the vehicle identification number (VIN)? ',
      },
      coInsured: {
        condo: {
          title: 'Does the condo have another owner?',
          subtitle:
            'A person is an owner if their name is on the land register. This person, considered co-insured, can act on your behalf to modify or cancel the policy.',
        },
        homeowner: {
          title: 'Does the house have another owner?',
          subtitle:
            'A person is an owner if their name is on the land register. This person, considered co-insured, can act on your behalf to modify or cancel the policy.',
        },
        tenant: {
          title: 'Would you like to add someone who lives with you as co-insured?',
          subtitle:
            'A co-insured can act on your behalf to modify or cancel the policy. Anyone related by blood is automatically covered and doesn’t need to be added as co-insured. <0></0><1></1> Important: The coverage limits you select should be sufficient to cover everyone on the policy.',
        },
      },
      licenceNumber: {
        description: {
          on: "The driver's licence number is shown at the top of the driver's licence. It is 15 characters long and begins with the first letter of the last name. If your driver licence is not from Ontario, contact us at contact@youset.ca or 514-613-6267.",
          qc: "The driver's licence number is shown at the top of the driver's licence. It is 13 characters long and begins with the first letter of the last name. If your driver licence is not from Quebec, contact us at contact@youset.ca or 514-613-6267.",
        },
        title: "Where can I find the driver's licence number?",
      },
    },
    placeholders: {
      coInsuredOccupation: 'ex. Engineering and sciences',
      coInsuredRelationship: 'Roommate',
      coInsuredWorkplace: 'ex. Starbucks',
      homeCreditor: {
        name: 'ex. National Bank',
        address: 'ex. 500 René-Lévesque West, Montreal',
      },
      licenceNumbers: {
        on: 'ex. L1234-12345-12345',
        qc: 'ex. L1234-120380-00',
      },
      occupation: 'ex. Engineering and sciences',
      workplace: 'ex. Starbucks',
    },
    prompts: {
      common: {
        footer: {
          buttons: {
            next: 'Next',
            recalculate: 'Yes',
            reject: 'No',
          },
          recalculate: 'Do you want to apply changes and recalculate the premium?',
        },
      },
      invalidReconstructionCost: {
        body: 'We estimated your house reconstruction cost to {{0}}. It is recommended to have a minimum house coverage of {{0}}.',
        header: {
          mainTitle: 'Important!',
          subtitle: 'Your house coverage is not sufficient. Please review it.',
        },
        reconstructionCost: 'House coverage selected',
      },
      invalidVin: {
        carDescriptionSelector: {
          description: 'The VIN provided does not match your {{0}}. Please select the  correct model of your vehicle:',
        },
        common: {
          vin: 'Provided VIN',
        },
        header: {
          mainTitle: 'Wrong Vin!',
          subtitle: 'There is an issue with the Vehicle Identification Number (VIN) you provided.',
        },
        vinEditor: {
          description: 'The VIN is  invalid. Please enter a valid VIN:',
          doesNotExists: 'This VIN does not exist. Please try again.',
          placeholder: 'Enter a new vin',
        },
      },
      carClaims: {
        header: {
          mainTitle: 'We verified your claims',
          subtitle:
            'We noticed some discrepancies when cross-checking the claims you reported with your Ontario Driver and Auto Search History (DASH) report.',
        },
        body: {
          title: 'Please review the list of claims recorded for each driver:',
          noClaims: 'No recent claims on record',
        },
      },
    },
    review: {
      subtitle: 'Please review the details of your policy.',
      title: 'Review Order',
    },
    subtitles: {
      carVins: 'What is the Vehicle Identification Number (VIN) of car <0>{{0}}</0>?',
      coInsured: {
        condo:
          'This might be your spouse or any other homeowner. All owners of the residence have to be named on the insurance policy. To insure 2 owners or more, contact us.',
        homeowner:
          'This might be your spouse or any other homeowner. All homeowners of the residence have to be named on the insurance policy. To insure 2 homeowners or more, contact us.',
        tenant:
          'A co-insured can act on your behalf to modify or cancel the policy. Anyone related by blood is automatically covered and doesn’t need to be added as co-insured.',
      },
      coInsuredSituation: 'How would you describe the person you are adding to the policy?',
      creditor: 'We will send them a copy of your policy by mail.',
      effectiveDate: {
        default: 'We can issue your policy up to a maximum of {{0}} days in advance',
        notaryDate: 'The date should be the date of signing at the notary.',
        moveInDate: 'The date should be on or after the move in date',
      },
      licenceNumber: 'What is <0>{{0}}’s</0> driver licence number?',
      main: 'We need to know a few more things about you',
    },
    titles: {
      mobileAppTracking: {
        intact:
          'To keep my Drive 10% discount, do all drivers agree to install and continuously use the Intact <0>my Drive</0> app on their smartphones?',
        travelers:
          'To keep the IntelliDrive discount, do all drivers agree to install and use the Travelers app on their smartphones during the 90-day evaluation period?',
      },
      carCreditors: {
        financed: 'Who is financing your <0>{{0}}</0> and what is their address?',
        leased: 'Who is financing your <0>{{0}}</0> and what is their address?',
      },
      coInsured: {
        condo: 'Does the condo have another owner?',
        homeowner: 'Does the house have another owner?',
        tenant: 'Would you like to add someone who lives with you as co-insured?',
      },
      effectiveDate: 'When do you want your {{0}} policy to start?',
      main: 'Finalize your order',
      mortgageLenders_one: 'What is the name and the address of your mortgage lender?',
      mortgageLenders_other: 'What are the names and the addresses of your mortgage lenders?',
      school: 'What is the name of the school you attend?',
      work: 'What’s the name of the company you work for?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
